import React from 'react';

import colors from 'assets/variables/colors';

const PopUpWrapper = ({
  children,
  onClick
}: {
  children: React.ReactNode;
  onClick: () => void;
}) => {
  return (
    <div
      style={{
        backgroundColor: colors.backgdrop,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default PopUpWrapper;
